const PROMOCAO_ATIVA = false;

const PRODUTO_A = 45237488124085;
const PRODUTO_B = 44972358041781;

let processando = false;

async function sincronizarCarrinho() {

    if (!PROMOCAO_ATIVA) return;

    if (processando) return;

    processando = true;

    try {

        const cart = await fetch('/cart.js').then(r => r.json());

        const itemA = cart.items.find(i => i.variant_id === PRODUTO_A);
        const itemB = cart.items.find(i => i.variant_id === PRODUTO_B);

        if (itemA && !itemB) {

            await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: PRODUTO_B,
                    quantity: 1
                })
            });

            document.dispatchEvent(new CustomEvent('cart:refresh'));

            return;
        }

        if (!itemA && itemB) {

            await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: itemB.key,
                    quantity: 0
                })
            });

            document.dispatchEvent(new CustomEvent('cart:refresh'));
        }

    } finally {

        processando = false;

    }
}

sincronizarCarrinho();

const originalFetch = window.fetch;

window.fetch = async (...args) => {

    const response = await originalFetch(...args);

    if (
        PROMOCAO_ATIVA &&
        typeof args[0] === 'string' &&
        (
            args[0].includes('/cart/add') ||
            args[0].includes('/cart/change') ||
            args[0].includes('/cart/update')
        )
    ) {

        setTimeout(sincronizarCarrinho, 300);

    }

    return response;
};